export interface GoogleHealthDayRow {
  date: string;
  steps: number;
  calories: number;
  distance: number;
  sleep_minutes: number;
  active_zone_minutes?: number;
  spo2: number | null;
  hrv: number | null;
  breathing_rate: number | null;
  skin_temperature: number | null;
  steps_goal?: number;
  calories_goal?: number;
}

export interface GoogleHealthPayload {
  user_id?: string | number;
  health_data: GoogleHealthDayRow[];
}

export const GOOGLE_HEALTH_STORAGE_KEY = "glucera_google_health_cache";
export const GOOGLE_HEALTH_EVENT = "glucera:health-data";

declare global {
  interface Window {
    GluceraAndroid?: {
      requestGoogleHealthData?: () => void;
    };
    GluceraWeb?: {
      onHealthData?: (payload: GoogleHealthPayload | string) => void;
      onHealthDataError?: (message: string) => void;
      /** Returns JSON string: { userId, accessToken } for Android CookieManager / bridge */
      getAuthContext?: () => string;
    };
  }
}

export {};
